import { SoundController } from "@lib/titan2-slingo/dist/game/controller/SoundController";
import { GameClawpawtraSoundEvents } from "../event/GameSountEvent";
import { MainTransitionEvents } from "../../view/abstract/display/GameMainTransition";
import { FeatureGoldFishEvents } from "../../view/abstract/display/features/goldfish/FeatureGoldFish";
export class GameSoundClawpawtraController extends SoundController {
    addEventListeners() {
        super.removeEventListeners();
        this.registerGame(FeatureGoldFishEvents.START, this.playMusic);
        this.registerGame(FeatureGoldFishEvents.ENABLE_LOCKS, this.handleLocks);
        this.registerGame(GameClawpawtraSoundEvents.YARN_IN, this.handleYarnIn);
        this.registerGame(GameClawpawtraSoundEvents.YARN_OUT, this.handleYarnOut);
        this.registerGame(GameClawpawtraSoundEvents.PICK, this.handlePick);
        this.registerGame(GameClawpawtraSoundEvents.REEL_SPIN, this.handleSpin);
        this.registerGame(GameClawpawtraSoundEvents.REEL_RESPIN, this.handleRespin);
        this.registerGame(GameClawpawtraSoundEvents.CASH_COLLECTED, this.handleCashCollected);
        this.registerGame(GameClawpawtraSoundEvents.APPLY_MULTIPLIER, this.handleApplyMultiplier);
        this.registerGame(GameClawpawtraSoundEvents.CAT_TELEPORT, this.handleTeleport);
        this.registerGame(GameClawpawtraSoundEvents.RESPIN_TRAIL_SWOOSH, this.handleClockTrailSwoosh);
        this.registerGame(GameClawpawtraSoundEvents.RESPIN_TRIGGER, this.handleRespinTriggered);
        this.registerGame(GameClawpawtraSoundEvents.COLLECT_SPIN_PICK, this.handleCollectSpinPick);
        this.registerGame(FeatureGoldFishEvents.EXIT_RESPINS, this.handleExitRespins);
        this.registerGame(GameClawpawtraSoundEvents.RESPIN_MULTIPLIER_INCREASE, this.handleRespinMultiplierIncrease);
        this.registerGame(MainTransitionEvents.BLACKOUT_MID_POINT, this.stopMusic);
    }
    playMusic() {
        this.music = this.playSound(this.getSoundPropertiesFromId("CLAW_MUSIC"));
        this.music.howl.rate(1);
    }
    stopMusic() {
        this.stopSound(this.getSoundPropertiesFromId("CLAW_MUSIC"));
        this.music = undefined;
    }
    handleYarnIn() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_YARN_IN"));
    }
    handleYarnOut() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_YARN_OUT"));
    }
    handlePick() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_YARN_PICK"));
    }
    handleLocks() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_LOCK"));
    }
    handleSpin() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_SPIN"));
    }
    handleRespin() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_RESPIN"));
    }
    handleCashCollected() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_CASH_COLLECTED"));
    }
    handleApplyMultiplier() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_APPLY_MULTIPLIER")).howl.rate(1.122);
    }
    handleClockTrailSwoosh() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_CLOCK_TRAIL_SWOOSH"));
    }
    handleCollectSpinPick() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_COLLECT_SPIN_PICK")).howl.rate(1.122);
        ;
    }
    handleRespinTriggered() {
        if (this.music) {
            const howl = this.music.howl;
            gsap.to(howl, {
                rate: 1.122,
                duration: 0.5
            });
        }
        this.playSound(this.getSoundPropertiesFromId("CLAW_RESPIN_TRIGGER"));
    }
    handleExitRespins() {
        if (this.music) {
            const howl = this.music.howl;
            gsap.to(howl, {
                rate: 1,
                duration: 0.5
            });
        }
    }
    handleRespinMultiplierIncrease() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_MULTIPLIER_INCREASE"));
    }
    handleTeleport() {
        this.playSound(this.getSoundPropertiesFromId("CLAW_CAT_TELEPORT"));
    }
}
//# sourceMappingURL=GameSoundClawpawtraController.js.map